export const TEST_ID = 'johnDeereIcon';
